import accountSettings from './accountSettings.json'
import ai from './ai.json'
import aiDetection from './aiDetection.json'
import analysis from './analysis.json'
import app from './app.json'
import area from './area.json'
import auth from './auth.json'
import clip from './clip.json'
import common from './common.json'
import companySettings from './companySettings.json'
import device from './device.json'
import firmware from './firmware.json'
import handsLicense from './handsLicense.json'
import map from './map.json'
import patlite from './patlite.json'
import privacyPolicy from './privacyPolicy.json'
import recording from './recording.json'
import shared from './shared.json'
import stream from './stream.json'
import tag from './tag.json'
import termsOfUse from './termsOfUse.json'
import user from './user.json'
import viewer from './viewer.json'

/**
 * 日本語カタログ。
 *
 * 名前空間ごとに JSON を分けて、ここで 1 つのオブジェクトへ合成する。
 * キーは `<名前空間>.<ファイル>.<役割>` の 3 階層を基本にする
 * （例: `clip.clipEditDialog.title`）。名前空間は原則 `src/features/<名前>` /
 * `src/widgets/<名前>` / `src/entities/<名前>` に対応させ、文脈に依存しない
 * 共通語だけを `common` へ置く。
 *
 * **i18next の resources へ同期的に渡す**（動的 import にしない）。
 * 非同期ロードにすると初回描画で一瞬空文字になり、VRT が中身の無い絵を
 * baseline として焼き付ける（`.claude/rules/vrt.md`）。
 *
 * このファイルは `scripts/i18n-extract.js` が生成する。手で編集しない。
 */
export const ja = {
  accountSettings,
  ai,
  aiDetection,
  analysis,
  app,
  area,
  auth,
  clip,
  common,
  companySettings,
  device,
  firmware,
  handsLicense,
  map,
  patlite,
  privacyPolicy,
  recording,
  shared,
  stream,
  tag,
  termsOfUse,
  user,
  viewer
}
